import React, { Component } from 'react';
import {Link, Redirect} from "react-router-dom";
import {CheckVal} from "./../../utils/functions";
import {CreateDbItem} from './../../utils/dbFunctions';
import BackButton from './../../components/backButton';
import {withRouter} from "react-router-dom";

export class AdminWebsiteAddCustomJob extends Component {

  constructor(props) {
      super(props);
      this.state={};
  }

  nameChange = (e) =>{
    let value = e.target.value;
    this.setState({
      name:value
    })
  }

  onSave = async() =>{
    if(this.state.name){
      let item = await CreateDbItem('WebsiteCustomJobs',[{key:'name', val:this.state.name}]);
      if(item){
        this.props.history.push('/admin/job/'+item.id);
      } else{
        alert('Something very strange happened')
      }
    } else{
      alert('Enter a name to create a bundle')
    }
  }
  componentDidMount = async() =>{
    let val = await CheckVal();
  }
  render() {
    return (
      <div className="full-height full-width">
        <div className="admin-hero-padding primary-background-dark">
          <div className="small-padding">
            <BackButton />
            <div className="row" style={{marginBottom:"10px"}}>
              <h2 className="white" style={{marginBottom:'0px'}}>{'Create a New Custom Job'}</h2>
            </div>
          </div>
        </div>
        <div className="large-padding">
          <div className="small-max-width-container" style={{marginLeft:0}}>
            <h6 className="full-width subheading" style={{marginTop:"20px"}}>{'Name'}</h6>
            <input
              className="full-width tiny-padding light-grey-background"
              value={this.state.name}
              onChange={this.nameChange}
              placeholder="Enter a Title" />
            <div onClick={this.onSave} className="button primary-background white">{'Create'}</div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(AdminWebsiteAddCustomJob)
